export default __webpack_public_path__ + "static/media/error-desktop.f6c94d70.svg";